import network from "@/api/network";

export default class News {
  static async getNewsList(page, perPage, data) {
    return await network.get(`news/list?page=${page}&per_page=${perPage}`, data, {});
  }

  static async uploadNewsImage(data) {
    return await network.post("news/image/upload", data, {});
  }

  static async addNews(data) {
    return await network.post("news", data, {});
  }

  static async editNews(data) {
    return await network.put("news", data, {});
  }

  static async deleteNews(data) {
    return await network.delete("news", data, {});
  }
}
